var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAgriOtherIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M1.876 7.577 13 1.155l11.124 6.422v12.846L13 26.845 1.876 20.423z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 14,
  r: 7,
  stroke: "#fff",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.64 10v3.63c-.864.32-1.44 1.17-1.44 2.12C8.2 17 9.16 18 10.36 18c1.1 0 2.021-.86 2.146-2h2.016c-.053.16-.082.33-.082.5 0 .398.152.78.422 1.06.27.282.636.44 1.018.44s.748-.158 1.018-.44a1.53 1.53 0 0 0 .336-1.56h.566v-1.5c0-.555-.427-1-.96-1h-2.38l-.668-3.5zm.96 1H13l.48 2.5V15h-1.085a2.26 2.26 0 0 0-.694-1.009 2.13 2.13 0 0 0-1.1-.476zm-.24 3.625c.287 0 .561.118.764.33.202.21.316.497.316.795s-.114.584-.316.796c-.203.21-.477.329-.764.329-.286 0-.56-.119-.763-.33a1.15 1.15 0 0 1-.317-.795c0-.298.114-.585.317-.796.202-.21.477-.329.763-.329m5.52 1.125c.191 0 .374.079.51.22.134.14.21.331.21.53s-.076.39-.21.53a.7.7 0 0 1-.51.22.7.7 0 0 1-.509-.22.77.77 0 0 1-.21-.53c0-.199.075-.39.21-.53a.7.7 0 0 1 .51-.22"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "m18.2 9.2-10 10"
})));
export default SvgAgriOtherIcon;